import { apiRequest } from "./client";

/**
 * NestJS calls contract (Sprint 4, Part 72 §72.6):
 * - GET /api/calls/:id            → call (org-scoped, 404 cross-org)
 * - GET /api/calls?contactId=     → contact call timeline
 */
export const callsApi = {
  listByContact: async (contactId) => {
    const data = await apiRequest(`/api/calls?contactId=${contactId}&page=1&size=50`);
    return (data?.items || []).map((call) => ({ ...call }));
  },
  get: (id) => apiRequest(`/api/calls/${id}`),
};
